(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eggi-product-hero"] && !Shopify.designMode) return;
  try {
    class EggiPdpHero extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('[data-eggi-hero-video]')];
      this.expression = this.querySelector('[data-eggi-hero-expression]');
      this.gazeTimer = 0;
      this.blinkTimer = 0;
      this.blinkResetTimer = 0;
      if (!this.videos.length && !this.expression) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.videoObserver = new IntersectionObserver(([entry]) => {
        this.videos.forEach((video) => {
          if (entry.isIntersecting) {
            if (!video.src) {
              video.src = video.dataset.src;
              video.load();
            }
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });

        if (entry.isIntersecting) this.startExpressionMotion();
        else this.stopExpressionMotion();
      }, { rootMargin: '120px 0px', threshold: .01 });
      this.videoObserver.observe(this);
    }

    startExpressionMotion() {
      if (!this.expression || this.gazeTimer || this.blinkTimer) return;
      this.scheduleGaze(500);
      this.scheduleBlink(1800);
    }

    scheduleGaze(delay = 0) {
      window.clearTimeout(this.gazeTimer);
      this.gazeTimer = window.setTimeout(() => {
        this.gazeTimer = 0;
        const directions = [
          [0, 0, 0],
          [-7, -2, -2.2],
          [7, -2, 2.2],
          [-5, 4, -1.2],
          [5, 4, 1.2],
          [0, -5, 0],
        ];
        const [x, y, tilt] = directions[Math.floor(Math.random() * directions.length)];
        this.expression.style.setProperty('--eggi-pdp-gaze-x', `${x}%`);
        this.expression.style.setProperty('--eggi-pdp-gaze-y', `${y}%`);
        this.expression.style.setProperty('--eggi-pdp-gaze-tilt', `${tilt}deg`);
        this.scheduleGaze(1200 + Math.random() * 2100);
      }, delay);
    }

    scheduleBlink(delay = 0) {
      window.clearTimeout(this.blinkTimer);
      this.blinkTimer = window.setTimeout(() => {
        this.blinkTimer = 0;
        this.expression.classList.add('is-blinking');
        this.blinkResetTimer = window.setTimeout(() => {
          this.expression.classList.remove('is-blinking');
          this.scheduleBlink(2400 + Math.random() * 2600);
        }, 110);
      }, delay);
    }

    stopExpressionMotion() {
      window.clearTimeout(this.gazeTimer);
      window.clearTimeout(this.blinkTimer);
      window.clearTimeout(this.blinkResetTimer);
      this.gazeTimer = 0;
      this.blinkTimer = 0;
      this.blinkResetTimer = 0;
      if (!this.expression) return;
      this.expression.classList.remove('is-blinking');
      this.expression.style.setProperty('--eggi-pdp-gaze-x', '0%');
      this.expression.style.setProperty('--eggi-pdp-gaze-y', '0%');
      this.expression.style.setProperty('--eggi-pdp-gaze-tilt', '0deg');
    }

    disconnectedCallback() {
      this.videoObserver?.disconnect();
      this.videos?.forEach((video) => video.pause());
      this.stopExpressionMotion();
    }
  }

  if (!customElements.get('eggi-pdp-hero')) customElements.define('eggi-pdp-hero', EggiPdpHero);
  } catch(e) { console.error(e); }
})();

})();
